import { useState } from "react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import Header from "@/components/layout/header";
import DiscoveryForm from "@/components/auto-discovery/discovery-form";

const AutoDiscoveryPage = () => {
  const [showDiscoveryModal, setShowDiscoveryModal] = useState(false);

  return (
    <div className="flex flex-col h-full">
      <Header title="Auto-Discovery" />
      
      <main className="flex-1 overflow-y-auto p-6 bg-[#F5F5F5]">
        <Card className="bg-white shadow max-w-4xl mx-auto">
          <CardHeader>
            <CardTitle className="text-xl font-medium">Auto-Discover Mappings</CardTitle>
            <CardDescription>
              Automatically discover and create field mappings based on field name similarities between KUP and HS systems.
            </CardDescription>
          </CardHeader>
          <CardContent className="pt-4">
            <div className="space-y-6">
              <div className="p-6 bg-blue-50 rounded-md">
                <h3 className="text-lg font-medium text-blue-800 mb-2">How Auto-Discovery Works</h3>
                <p className="text-sm text-blue-700 mb-4">
                  Auto-discovery analyzes field names in both KUP and HS systems to find matching pairs. The process:
                </p>
                <ol className="list-decimal pl-5 space-y-2 text-sm text-blue-700">
                  <li>Examines entities you select</li>
                  <li>Finds fields with similar names (e.g., pl_kup_title and pl_hs_title)</li>
                  <li>Creates field mappings with your selected default sync mode</li>
                  <li>For choice fields, discovers and creates option set value mappings</li>
                </ol>
              </div>
              
              <div className="flex flex-col space-y-4">
                <div className="flex space-x-2 items-center">
                  <span className="material-icons text-blue-500">info</span>
                  <p className="text-sm text-gray-600">
                    This feature can save significant time when setting up initial mappings.
                  </p>
                </div>
                <div className="flex space-x-2 items-center">
                  <span className="material-icons text-amber-500">warning</span>
                  <p className="text-sm text-gray-600">
                    Auto-discovery may not find all mappings. Review results and add missing mappings manually.
                  </p>
                </div>
                <div className="flex space-x-2 items-center">
                  <span className="material-icons text-green-500">check_circle</span>
                  <p className="text-sm text-gray-600">
                    You can still edit all discovered mappings after they're created.
                  </p>
                </div>
              </div>
              
              <div className="flex justify-center">
                <Button 
                  onClick={() => setShowDiscoveryModal(true)}
                  className="bg-[#0078D4] hover:bg-[#2B88D8] px-8"
                >
                  Start Auto-Discovery
                </Button>
              </div>
            </div>
          </CardContent>
        </Card>
      </main>

      {showDiscoveryModal && (
        <DiscoveryForm
          isOpen={showDiscoveryModal}
          onClose={() => setShowDiscoveryModal(false)}
          onSuccess={() => setShowDiscoveryModal(false)}
        />
      )}
    </div>
  );
};

export default AutoDiscoveryPage;
